import React from 'react';

import {
    Input,
    Row,
    Col,
    Select,
    Button,
    Popconfirm,
    Icon,
    DatePicker,
    InputNumber 
} from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;

const CONDITIONS_WITHOUT_INPUT = ['exists','does-not-exist']
class FilterRow extends React.Component {

    render() {

        return (
            <Row 
                className='filter-row'
                gutter={4}>
                <Col span={6}>
                    {this.renderFieldNameField()}
                </Col>
                <Col span={6}>
                    {this.renderConditionField()}
                </Col>
                <Col span={11}>
                    {!CONDITIONS_WITHOUT_INPUT.includes(this.props.condition) && this.renderInputField()}
                </Col>
                <Col span={1}>
                    {this.props.deleteActive && <Popconfirm
                        title="Are you sure?"
                        onConfirm={this.onRemove}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            className="variant-delete-button"
                            // onClick={this.handleDeleteVariant}
                            shape="circle"
                            size="small">
                            <Icon style={{ color: 'red' }} type="delete" />
                        </Button>
                    </Popconfirm>}
                </Col>
            </Row>
        )
    }

    renderFieldNameField = () => {

        const {fieldNames, fieldName} = this.props;

        return (
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a field name"
                optionFilterProp="children"
                onChange={(value) => this.onFieldChange(value, 'fieldName')}
                // onFocus={onFocus}
                // onBlur={onBlur}
                // onSearch={onSearch}
                value={fieldName}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {
                    fieldNames.map(_fieldName => {
                        return <Option value={_fieldName.key}>{_fieldName.key}</Option>
                    })
                }
            </Select >
        )
    }

    renderConditionField = () => {

        const {fieldNames, fieldName } = this.props;
        const type = fieldNames.filter(f => f.key ===fieldName)[0] ? fieldNames.filter(f => f.key ===fieldName)[0].type : 'STRING'

        var options = []

        switch (type) {
            case 'STRING':
                options = [{
                    value: 'equal-to',
                    text: 'Equal To'
                },{
                    value: 'not-equal-to',
                    text: 'Not Equal to'
                },{
                    value: 'contains',
                    text: 'Contains'
                },{
                    value: 'does-not-contain',
                    text: 'Does Not Contain'
                },{
                    value: 'exists',
                    text: 'Exists'
                },{
                    value: 'does-not-exist',
                    text: 'Does Not Exist'
                }]
                break;
            case 'BOOLEAN':
                options = [{
                    value: 'equal-to',
                    text: 'Equal To'
                },{
                    value: 'not-equal-to',
                    text: 'Not Equal to'
                },{
                    value: 'exists',
                    text: 'Exists'
                },{
                    value: 'does-not-exist',
                    text: 'Does Not Exist'
                }]
                break;
            case 'DATE': 
                options = [{
                    value: 'between',
                    text: 'Between'
                },{
                    value: 'exists',
                    text: 'Exists'
                },{
                    value: 'does-not-exist',
                    text: 'Does Not Exist'
                }]
                break;
            case 'INTEGER':
                options = [{
                    value: 'greater-than',
                    text: '>'
                },{
                    value: 'greater-than-equal',
                    text: '>='
                },{
                    value: 'less-than',
                    text: '<'
                },{
                    value: 'less-then-equal',
                    text: '<='
                },{
                    value: 'equal-to',
                    text: '='
                },{
                    value: 'not-equal-to',
                    text: '!='
                }]
                break;
            case 'FLOAT':
                options = [{
                    value: 'greater-than',
                    text: '>'
                },{
                    value: 'greater-than-equal',
                    text: '>='
                },{
                    value: 'less-than',
                    text: '<'
                },{
                    value: 'less-then-equal',
                    text: '<='
                },{
                    value: 'equal-to',
                    text: '='
                },{
                    value: 'not-equal-to',
                    text: '!='
                }]
                break;
            default:
                options = [{
                    value: 'equal-to',
                    text: 'Equal To'
                },{
                    value: 'not-equal-to',
                    text: 'Not Equal to'
                }]
                break;
        }

        return <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Select a condition"
            optionFilterProp="children"
            onChange={(value) => this.onFieldChange(value, 'condition')}
            value={this.props.condition}
            // onFocus={onFocus}
            // onBlur={onBlur}
            // onSearch={onSearch}
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >   
            {options.map(_option => {
                return <Option value={_option.value}>{_option.text}</Option>
            })}
        </Select>
    }

    renderInputField = () => {

        const {fieldNames, fieldName, value} = this.props;
        const type = fieldNames.filter(f => f.key ===fieldName)[0] ? fieldNames.filter(f => f.key ===fieldName)[0].type : 'STRING'

        switch(type) {
            case 'STRING':
                return <Input
                    id="value"
                    onChange={(value) => this.onFieldChange(value.target.value, 'value')}
                    value={value}
                />
            case 'BOOLEAN':
                return <Select
                            style={{width: '100%'}}
                            onChange={(value) => this.onFieldChange(value, 'value')}
                            >
                    <Option value="true">True</Option>
                    <Option value="false">False</Option>
                </Select>
            case 'DATE': 
                return <RangePicker
                            style={{width: '100%'}}
                            onChange={(value) => this.onFieldChange(value, 'value')}
                            />
            case 'INTEGER':
                return <InputNumber 
                            onChange={(value) => this.onFieldChange(value, 'value')}
                            />
            default:
                return <Input
                id="value"
                onChange={(value) => this.onFieldChange(value.target.value, 'value')}
                value={value}
            />

        }


    }

    onFieldChange = (value, field) => {
        this.props.onFieldChange(value, field, this.props.index)
    }

    onRemove = () => {
        this.props.removeQuery(this.props.index)
    }
}

export default FilterRow


// WEBPACK FOOTER //
// ./src/components/data/filter-row.js